module.exports = __webpack_public_path__ + "static/media/Post box 2.84497c78.jpg";